import { render, staticRenderFns } from "./FormasPago.vue?vue&type=template&id=6b2c776a"
import script from "./FormasPago.vue?vue&type=script&lang=js"
export * from "./FormasPago.vue?vue&type=script&lang=js"
import style0 from "./FormasPago.vue?vue&type=style&index=0&id=6b2c776a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports